import { render, staticRenderFns } from "./PoEmailTemplate.vue?vue&type=template&id=4306cb33&scoped=true"
import script from "./PoEmailTemplate.vue?vue&type=script&lang=ts"
export * from "./PoEmailTemplate.vue?vue&type=script&lang=ts"
import style0 from "./PoEmailTemplate.vue?vue&type=style&index=0&id=4306cb33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306cb33",
  null
  
)

export default component.exports